export const extractProductsFromWidgets = (widgetList) =>
    widgetList &&
    Array.isArray(widgetList) &&
    widgetList.reduce((productList, { widget = {} }) => {
        return productList.concat(widget.products || []);
    }, []);
